import request from '@/axios'

// 电表列表
export function getDevice(data={}) {
    return request({
        url: '/pay/room/elecList',
        method: 'get',
        params: data
    })
}
// 电表列表
export function export_excel(data={}) {
    return request({
        url: '/pay/room/elec/export',
        method: 'get',
        params: data
    })
}
// 导入电表和房间
export function importDevice(data={}) {
    return request({
        url: '/base/room/import',
        method: 'post',
        data
    })
}
// 查询电表读表记录
export function getDeviceRecord(data={}) {
    return request({
        url: '/pay/room/elecRecord',
        method: 'get',
        params: data
    })
}
// 查询电表读表记录-导出
export function exportDeviceRecord(data={}) {
    return request({
        url: '/pay/room/elecRecord/export',
        method: 'get',
        params: data
    })
}
// 查询电表离线记录
export function getDeviceOffline(data={}) {
    return request({
        url: '/pay/room/elecOffline',
        method: 'get',
        params: data
    })
}
// 查询电表告警记录
export function getDeviceAlarm(data={}) {
    return request({
        url: '/pay/room/elecAlarm',
        method: 'get',
        params: data
    })
}
